import * as React from "react";
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";


class InstaDocTokenRefresh extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timerHandle: null
        };
        this.StartTimer = this.StartTimer.bind(this);
        this.TimerTick = this.TimerTick.bind(this);
        this.EndTimer = this.EndTimer.bind(this);
    }

    componentDidMount() {
        this.StartTimer();
    }

    componentDidUpdate(prevState, prevProps) {
        this.StartTimer();
    }

    componentWillUnmount() {
        this.EndTimer();
    }

    StartTimer() {
        var { timerHandle } = this.state;
        if (!timerHandle) {
            timerHandle = window.setInterval(this.TimerTick, window.serverData.data.instaDocTokenRefreshMinutes * 60000);
            this.setState({ timerHandle: timerHandle });
        }
    }

    EndTimer() {
        const { timerHandle } = this.state;
        if (timerHandle) {
            window.clearInterval(timerHandle);
            this.setState({ timerHandle: null });
        }
    }

    TimerTick() {
        const { Refresh } = this.props;
        if (Refresh) {
            Refresh();
        }
    }

    render() {
        return (
            <React.Fragment />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        token: state.domain.adt,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        Refresh: () => {
            dispatch({ type: types.INSTADOC_TOKEN_REFRESH });
        },

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstaDocTokenRefresh);


